import { supabase } from '@/lib/supabase';
import { detectPlatform } from '@/lib/pushDevices';

// ─────────────────────────────────────────────────────────────
// Suivi des installations de l'application PWA.
// Chaque « installation » (événement appinstalled du navigateur) est
// journalisée dans `pwa_installs` pour alimenter les statistiques du
// SuperAdmin. Tout est BEST-EFFORT.
// ─────────────────────────────────────────────────────────────

export async function recordPwaInstall(userId?: number | null): Promise<void> {
  try {
    await supabase.from('pwa_installs').insert({
      user_id: userId ?? null,
      platform: detectPlatform(),
    });
  } catch {
    /* best-effort : ne jamais bloquer l'installation */
  }
}

export interface PwaInstallStats {
  total: number;
  last30: number;
  byPlatform: Record<string, number>;
}

function platformLabel(key: string): string {
  const map: Record<string, string> = {
    ios: 'iPhone / iPad',
    android: 'Android',
    windows: 'Windows',
    mac: 'Mac',
    linux: 'Linux',
    web: 'Web / autre',
    unknown: 'Inconnu',
  };
  return map[key] || key;
}

export { platformLabel };

export async function fetchPwaInstallStats(): Promise<PwaInstallStats> {
  const empty: PwaInstallStats = { total: 0, last30: 0, byPlatform: {} };
  try {
    const { data, error } = await supabase
      .from('pwa_installs')
      .select('platform, created_at');
    if (error) throw error;
    const rows = (data || []) as { platform: string | null; created_at: string | null }[];
    const cutoff = Date.now() - 30 * 24 * 60 * 60 * 1000;
    const byPlatform: Record<string, number> = {};
    let last30 = 0;
    rows.forEach((r) => {
      const key = (r.platform || 'unknown').toLowerCase();
      byPlatform[key] = (byPlatform[key] || 0) + 1;
      const ts = r.created_at ? new Date(r.created_at).getTime() : 0;
      if (ts >= cutoff) last30 += 1;
    });
    return { total: rows.length, last30, byPlatform };
  } catch {
    return empty;
  }
}